import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from "react-redux";

import gommeStore from "../stores/gomme-store.js";

import { WheelSearchByCar } from "./search/wheel-search-by-car.jsx";
import { ProgressIndicator } from "./shared/progress-indicator.jsx";
import { UserJoin } from './shared/user-join.jsx';
import { NavBar } from "./shared/navbar.jsx";
import { Ads } from "./shared/ads.jsx";

import { Post } from './shared/post.jsx';
import { CarSearchLinks } from "./search/car-search-links.jsx";
import { DiameterSearchLinks } from "./search/wheel-diameter-search-links.jsx";
import { WheelSearchLinks } from "./search/wheel-search-links.jsx";
import { WheelSearchLabels } from "./search/wheel-search-labels.jsx";

import { NavPhone, NavLogin, ContactCenterLinkTo } from "./shared/navbar.jsx";
import { NavMiniCart } from "./cart/nav-mini-cart.jsx";

import { HostSwitcher } from "./shared/host-switcher.jsx";
import { Video } from "./shared/video.jsx";

import { CouponBox } from "./shared/coupon-box.jsx";

//import GTagHelper from "./helper-google.js"

//GTagHelper

import { ToolTip } from "./shared/tooltip.jsx";

window.reactToolTip = function (event, modalOpen, text) {
  event = event || window.event;
   
  if (event) {
    event.preventDefault();
    event.stopPropagation();
  }

  var tooltip = document.querySelectorAll('#tooltip');

  if (tooltip && (tooltip.length > 0)) {
    ReactDOM.render(
      <ToolTip
        modalOpen={modalOpen}
        setModalOpen={window.reactToolTip}
        text={text}
      />,
      tooltip[0]
    );
  }
}

var couponBoxs = document.querySelectorAll('.coupon-box');
[].forEach.call(couponBoxs, (couponBox, i) => {
  //  var json = JSON.parse(couponBox.dataset.video || "{}");

  ReactDOM.render(
    <Provider store={gommeStore}>
      <CouponBox
      />
    </Provider>,
    couponBox
  );
});

var videos = document.querySelectorAll('.video');
[].forEach.call(videos, (video, i) => {
  var json = JSON.parse(video.dataset.video || "{}");

  ReactDOM.render(
    <Video
      key={"video" + i}
      id={json.id}
      rateo={json.rateo}
    />,
    video
  );
});


if (document.getElementById('contact-center-link-to')) {
  ReactDOM.render(
    <ContactCenterLinkTo />,
    document.getElementById('contact-center-link-to')
  );
}

if (document.getElementById('join-complete')) {
  ReactDOM.render(
    <UserJoin />,
    document.getElementById('join-complete')
  );
}

var navphones = document.querySelectorAll('#nav-phone');
[].forEach.call(navphones, (navphone, i) => {
  ReactDOM.render(
    <Provider store={gommeStore}>
      <NavPhone
        key={"NavPhone" + i}
      />
    </Provider>,
    navphone
  );
});

var navlogins = document.querySelectorAll('#nav-login');
[].forEach.call(navlogins, (navlogin, i) => {
  var user = {};
  if (window.hasOwnProperty('globalUser')) {
    user = window.globalUser;
  }
  ReactDOM.render(
    <Provider store={gommeStore}>
      <NavLogin
        key={"NavLogin" + i}
        user={user}
      />
    </Provider>,
    navlogin
  );
});

var navcarts = document.querySelectorAll('#nav-cart');
[].forEach.call(navcarts, (navcart, i) => {
  ReactDOM.render(
    <Provider store={gommeStore}>
      <NavMiniCart
        key={"NavCart" + i}
        show={false}
      />
    </Provider>,
    navcart
  );
});

var el = document.getElementById('progress-indicator');
if (el) {
  ReactDOM.render(
    <Provider store={gommeStore}>
      <ProgressIndicator />
    </Provider>,
    el
  );
}

/*
el = document.getElementById('search-by-car');
if (el) {
  var target = el.dataset.target;
  var searchType = el.dataset.searchType;
  ReactDOM.render(
    <Provider store={gommeStore}>
      <SearchByCar target={target} searchType={searchType}/>
    </Provider>,
    el
  );
}
*/

el = document.getElementById('search-by-car');
var isSearchPage = (window.globalData || {}).isSearchPage || false;
if (el) {
  var searchType = el.dataset.searchType;
  ReactDOM.render(
    <Provider store={gommeStore}>
      <WheelSearchByCar searchType={searchType} isSearchPage={isSearchPage} />
    </Provider>,
    el
  );
}

//el = document.getElementById('car-search-links');
//if (el) {
//  var infos = el.dataset.infos;
//  ReactDOM.render(
//    <Provider store={gommeStore}>
//      <CarSearchLinks infos={(infos || "") != "" ? JSON.parse(infos) : null} />
//    </Provider>,
//    el
//  );
//}

el = document.getElementById('wheel-diameter-search-links');
if (el) {
  ReactDOM.render(
    <Provider store={gommeStore}>
      <DiameterSearchLinks /> 
    </Provider>,
    el
  );
}

el = document.getElementById('wheel-search-links');
if (el) {
  ReactDOM.render(
    <Provider store={gommeStore}>
      <WheelSearchLinks />
    </Provider>,
    el
  );
}

el = document.getElementById('wheel-search-car-labels');
if (el) {
  ReactDOM.render(
    <Provider store={gommeStore}>
      <WheelSearchLabels />
    </Provider>,
    el
  );
}

el = document.getElementById('div-post');
if (el) {
  ReactDOM.render(
    <Provider store={gommeStore}>
      <Post />
    </Provider>,
    el
  );
}

var switcher = document.getElementById('host-switcher');
if (switcher) {
  var roots = switcher.dataset.roots;
  var root = switcher.dataset.root;
  ReactDOM.render(
    <HostSwitcher
      roots={roots ? JSON.parse(roots) : null}
      root={root ? root : ""}
      />,
    switcher
  );
}

//var navbar = document.getElementById('full-top-navbar');
//if (navbar) {
//  var user = navbar.dataset.user;
//  ReactDOM.render(
//    <NavBar user={user ? JSON.parse(user) : null}
//    />,
//    navbar
//  );
//}

var ads = document.querySelectorAll('#ads');
[].forEach.call(ads, (ads, i) => {
  var key = ads.dataset.key;
  var id = ads.dataset.id;
  var adid = ads.dataset.adid;
  var img = ads.dataset.img;
  var url = ads.dataset.url;
  var style = ads.dataset.style;
  ReactDOM.render(
    <Ads
      id={id}
      adid={adid}
      img={img}
      url={url}
      style={style}
    />,
    ads
  );
});